module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-calculator-input"
    }
  }, [_c('div', [_c('h1', {
    staticClass: "input-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, _vm._l((_vm.fieldGroups), function(fieldGroup) {
    return _c('div', {
      staticClass: "field-group"
    }, [(fieldGroup.name) ? _c('h2', {
      staticClass: "field-group-title"
    }, [_vm._v(_vm._s(fieldGroup.name))]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "field-group-fields"
    }, _vm._l((fieldGroup.fields), function(field) {
      return _c('tr', {
        key: field.id,
        staticClass: "field"
      }, [_c('td', {
        staticClass: "field-label"
      }, [_c('label', {
        attrs: {
          "for": field.name
        }
      }, [_vm._v(_vm._s(field.label))])]), _vm._v(" "), _c('td', {
        staticClass: "field-input"
      }, [(field.type === 'text') ? [_c('input', {
        attrs: {
          "name": field.name,
          "type": field.type,
          "placeholder": field.placeholder
        },
        domProps: {
          "value": field.value
        },
        on: {
          "input": function($event) {
            _vm.modifyData(field, $event)
          },
          "keyup": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            _vm.trySubmit($event)
          }
        }
      })] : _vm._e(), _vm._v(" "), (field.type === 'radio') ? [_c('span', {
        staticClass: "radio-group"
      }, _vm._l((field.options), function(option, index) {
        return _c('span', {
          staticClass: "radio-input"
        }, [_c('input', {
          attrs: {
            "name": field.name,
            "type": field.type,
            "disabled": option.disabled
          },
          domProps: {
            "value": option.value,
            "checked": option.checked
          },
          on: {
            "change": function($event) {
              _vm.modifyData(field, $event);
              _vm.checkButton(field, option)
            }
          }
        }), _c('span', {
          staticClass: "radio-text"
        }, [_vm._v(_vm._s(option.text))])])
      }))] : _vm._e(), _vm._v(" "), (field.type === 'select') ? [_c('select', {
        on: {
          "input": function($event) {
            _vm.modifyData(field, $event)
          }
        }
      }, [_c('option', {
        attrs: {
          "selected": "",
          "disabled": ""
        }
      }, [_vm._v(_vm._s(field.defaultOption))]), _vm._v(" "), _vm._l((field.options), function(option) {
        return _c('option', {
          domProps: {
            "value": option.value
          }
        }, [_vm._v(_vm._s(option.text))])
      })], 2)] : _vm._e(), _vm._v(" "), (field.validate) ? [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (field.warning),
          expression: "field.warning"
        }],
        staticClass: "field-warning"
      }, [_vm._v("\n                  " + _vm._s(field.valid.message) + "\n                ")])] : _vm._e()], 2)])
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('custom-button', {
    class: {
      isValid: _vm.allFieldsValid
    },
    on: {
      "customButtonClick": _vm.trySubmit
    }
  }, [_vm._t("button")], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-abf8b830!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!./components/CalculatorInput.vue
// module id = 112
// module chunks = 0